<template>
  <div class="course-section" ref="self">
      <img :src="images.course" @load="emitReady">
      <div class="course-item">
        <img :src="images.courseTitle01" @click="toggleExpand(1)">
        <transition name="fade">
          <img v-show="expand01" :src="images.courseContent01">
        </transition>
        <img class="expand" :src="expand01 ? images.up : images.down" @click="toggleExpand(1)">
      </div>
      <!-- <div class="course-item">
        <img :src="images.courseTitle02" @click="toggleExpand(2)">
        <transition name="fade">
          <img v-show="expand02" :src="images.courseContent02">
        </transition>
        <img class="expand" :src="expand02 ? images.up : images.down" @click="toggleExpand(2)">
      </div> -->
      <div class="course-item">
        <img :src="images.courseTitle03" @click="toggleExpand(3)">
        <transition name="fade">
          <img v-show="expand03" :src="images.courseContent03">
        </transition>
        <img class="expand" :src="expand03 ? images.up : images.down" @click="toggleExpand(3)">
      </div>
      <div class="course-item">
        <img :src="images.courseTitle04" @click="toggleExpand(4)">
        <transition name="fade">
          <img v-show="expand04" :src="images.courseContent04">
        </transition>
        <img class="expand" :src="expand04 ? images.up : images.down" @click="toggleExpand(4)">
      </div>
      <div class="course-item">
        <img :src="images.courseTitle05" @click="toggleExpand(5)">
        <transition name="fade">
          <img v-show="expand05" :src="images.courseContent05">
        </transition>
        <img class="expand" :src="expand05 ? images.up : images.down" @click="toggleExpand(5)">
      </div>
  </div>
</template>

<script>
import images from '@/utils/images.js'
import active from './active.js'
export default {
    mixins: [active],
    data () {
        return {
            images: images,
            expand01: false,
            expand02: false,
            expand03: false,
            expand04: false,
            expand05: false,
            index: 2
        }
    },
    methods: {
      toggleExpand (index) {
        this['expand0' + index] = !this['expand0' + index];
        setTimeout(() => {
          this.$parent.getOffsetTops();
        }, 0);
      }
    }
}
</script>

<style lang="scss" scoped>
.course-section {
    font-size: 0;
    position: relative;

    .course-item {
        position: relative;
        .expand {
            position: absolute;
            right: 60px;
            top: 16px;
            width: 50px;
        }
    }
}

.fade-enter-active, .fade-leave-active {
  transition: height 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0;
}
</style>